/**
 * The venue types the venue application accepts (value = the API's venue_type). A tiny module
 * of its own so marketing pages (For Venues' "Who it's for") can list them without importing
 * the application's form model (react-hook-form / zod stay in the lazy /venue/apply chunk).
 */
export const VENUE_TYPES = Object.freeze([
  { value: 'bar', label: 'Bar' },
  { value: 'restaurant', label: 'Restaurant' },
  { value: 'cafe', label: 'Café' },
  { value: 'pub', label: 'Pub' },
  { value: 'brewery', label: 'Brewery' },
  { value: 'lounge', label: 'Lounge' },
  { value: 'other', label: 'Other' },
]);
